import api, {deleteFn, getFn, IdApiArg, insertFn, UpdateArg, updateFn, UpdateResp} from "../../api";
import {Tables, TablesInsert, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export const peopleApi = api.injectEndpoints({
    endpoints: (build) => ({

        // Machine types
        getPerson: build.query<Tables<"worker">[], PersonFilter>({
            queryFn: async (args) => {
                let q = supabase
                    .from("worker")
                    .select("*")

                if (args.active === true || args.active === false) {
                    q = q.eq("Active", args.active)
                }
                if (args.code) {
                    q = q.eq("code", args.code)
                }
                const {data, error} = await q.order("lastName");

                if (error) return {error};
                return {data}
            },
            providesTags: ["Person"]
        }),
        getUnregisteredWorkers: build.query<Tables<"unregistered_workers">[], void>({
            queryFn: async (args) => {
                let q = supabase
                    .from("unregistered_workers")
                    .select("*")
                const {data, error} = await q.order("lastName");
                if (error) return {error};
                return {data}
            },
            keepUnusedDataFor: 1,
        }),
        getPersonById: build.query<Tables<"worker"> | null, IdApiArg>({
            query: getFn("worker"),
            providesTags: ["Person"]
        }),
        postPerson: build.mutation<UpdateResp, TablesInsert<"worker">>({
            query: insertFn("worker"),
            invalidatesTags: ["Person"],
        }),
        deletePersonById: build.mutation<UpdateResp, IdApiArg>({
            query: deleteFn("worker"),
            invalidatesTags: ["Person"],
        }),
        putPersonById: build.mutation<UpdateResp, UpdateArg<"worker">>({
            query: updateFn("worker"),
            invalidatesTags: ["Person"],
        }),
    })
});

export interface PersonFilter {
    active?: boolean,
    code?: string
}


export type PersonApiPut = TablesUpdate<"worker">

export type PersonApiGet = Tables<"worker">


export const {
    useGetUnregisteredWorkersQuery,
    useGetPersonQuery,
    useGetPersonByIdQuery,
    usePostPersonMutation,
    usePutPersonByIdMutation,
    useDeletePersonByIdMutation,

} = peopleApi;
